import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconFileDesign';
/** Renders an SVG icon. */
const SvgFileDesign = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M27.707 8.293A1 1 0 0 1 28 9v18a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h14a1 1 0 0 1 .707.293zM26 27V10h-5a1 1 0 0 1-1-1V4H7a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1M22 5.414V8h2.586zM21 18a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1V14a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-4v8h8v-4a1 1 0 0 1 1-1"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20.722 12.072a.925.925 0 0 1 1.017.205l.988.993a.923.923 0 0 1 0 1.31l-4.587 4.608a.36.36 0 0 1-.16.094l-2.518.704a.363.363 0 0 1-.449-.448l.706-2.517a.37.37 0 0 1 .093-.16l4.61-4.585a.9.9 0 0 1 .3-.204"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M9 23a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm0-10a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm10 10a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"
      />
    </svg>
  );
};
SvgFileDesign.displayName = displayName;
export default SvgFileDesign;
